import React from "react";
import { useQuery } from "@tanstack/react-query";
import { backendApi } from "@/api/backendApi";
import JobCard from "./JobCard";

export default function RecentlyViewedJobsWidget() {
    const { data: recentJobs, isLoading } = useQuery({
        queryKey: ["jobs", "recent"],
        queryFn: () => backendApi.entities.Job.getRecent(),
        staleTime: 60000,
        enabled: !!backendApi.auth.getToken(),
    });

    if (isLoading) {
        return <div className="p-6 mb-6">Loading recently viewed jobs...</div>;
    }

    if (!recentJobs || recentJobs.length === 0) {
        return (
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-6">
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-gray-900 font-semibold">Recently Viewed Jobs</h3>
                </div>
                <div className="text-gray-500 italic text-center py-4">
                    You haven't viewed any jobs recently. Check out our recommended jobs!
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-6">
            <div className="flex justify-between items-center mb-6">
                <h3 className="text-gray-900 font-semibold">Recently Viewed Jobs</h3>
                <button className="text-[#2557a7] text-sm font-medium hover:underline">
                    View all
                </button>
            </div>

            {/* Reusing JobCard array in a grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
                {recentJobs.slice(0, 4).map((job) => (
                    <JobCard
                        key={job.id}
                        job={job}
                        onSave={() => { }}
                        isSaved={false}
                        onApply={() => { }}
                        isApplied={false}
                        isActionLoading={false}
                    />
                ))}
            </div>
        </div>
    );
}
